<section
  class="surface-0 border-round p-5 mb-4 shadow-1"
  role="region"
  aria-labelledby="section-operating-address"
>
  <!-- Live region per screen reader (aggiungi/rimuovi sede) -->
  <div role="status" aria-live="polite" aria-atomic="true" class="visually-hidden">
    {{ liveRegionMessage() }}
  </div>

  <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
    <i class="pi pi-map-marker text-3xl text-primary" aria-hidden="true"></i>
    <div>
      <h2 id="section-operating-address" class="text-2xl font-semibold m-0 text-900">
        Sede Operativa
      </h2>
      @if (!readonly()) {
        <p class="text-600 m-0 mt-1">
          Indica se la sede legale è anche operativa e aggiungi le eventuali sedi operative aggiuntive
        </p>
      }
    </div>
  </div>

  <!-- Flag: la sede legale è anche una sede operativa? -->
  <div class="mb-4">
    <label class="font-semibold block mb-2">
      La sede legale è anche una sede operativa?
      <span class="text-red-500" aria-hidden="true">*</span>
      <i
        class="pi pi-info-circle ml-2 text-500"
        aria-hidden="true"
        [pTooltip]="siteTooltip"
        tooltipPosition="top"
      ></i>
    </label>
    <div class="flex gap-4">
      <div class="flex align-items-center">
        <p-radiobutton
          name="operatingSameAsLegal"
          [value]="true"
          [ngModel]="sameAsLegal()"
          (ngModelChange)="sameAsLegal.set($event)"
          inputId="op-same-legal-si"
          [disabled]="readonly()"
          ariaLabel="Sì"
        />
        <label for="op-same-legal-si" class="ml-2">Sì</label>
      </div>
      <div class="flex align-items-center">
        <p-radiobutton
          name="operatingSameAsLegal"
          [value]="false"
          [ngModel]="sameAsLegal()"
          (ngModelChange)="sameAsLegal.set($event)"
          inputId="op-same-legal-no"
          [disabled]="readonly()"
          ariaLabel="No"
        />
        <label for="op-same-legal-no" class="ml-2">No</label>
      </div>
    </div>
  </div>

  <!-- Lista sedi operative aggiuntive -->
  <div class="flex align-items-center justify-content-between mb-3">
    <div class="flex align-items-center gap-2">
      <h3 class="text-lg font-semibold m-0 text-900">Sedi operative</h3>
      <i
        class="pi pi-info-circle text-500"
        aria-hidden="true"
        [pTooltip]="siteTooltip"
        tooltipPosition="top"
      ></i>
    </div>
    @if (!readonly()) {
      <button
        pButton
        type="button"
        label="Aggiungi sede"
        icon="pi pi-plus"
        class="p-button-outlined p-button-sm"
        [pTooltip]="siteTooltip"
        tooltipPosition="top"
        [attr.aria-label]="'Aggiungi una sede operativa'"
        (click)="addSite()"
      ></button>
    }
  </div>

  @if (missingRequiredSite()) {
    <small class="text-red-500 block mb-3" role="alert">
      Se la sede legale non è operativa, indica almeno una sede operativa.
    </small>
  }

  @if (sites().length === 0) {
    <div class="surface-50 border-round p-3 text-600 text-sm">
      @if (sameAsLegal()) {
        Nessuna sede operativa aggiuntiva. La sede legale è considerata operativa; puoi comunque aggiungere altre sedi.
      } @else {
        Nessuna sede operativa indicata. Aggiungi almeno una sede operativa.
      }
    </div>
  }

  @for (site of sites(); track site.key) {
    <div class="surface-50 border-round p-3 mb-3">
      <div class="flex align-items-center justify-content-between mb-3">
        <h4 class="text-base font-semibold m-0 text-900">Sede operativa {{ $index + 1 }}</h4>
        @if (!readonly()) {
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            class="p-button-text p-button-danger p-button-sm"
            pTooltip="Elimina sede"
            tooltipPosition="top"
            [attr.aria-label]="'Elimina sede operativa ' + ($index + 1)"
            (click)="removeSite(site)"
          ></button>
        }
      </div>
      <app-operating-site-form
        [site]="site"
        [readonly]="readonly()"
        [formSubmitted]="formSubmitted()"
      />
    </div>
  }
</section>
